export default __webpack_public_path__ + "static/media/tile-4-short.79b9fade.png";